<template>
  <mailing-list
    submit-text="Submit"
    placeholder="email address"
    provider="mailchimp"
    actionUrl="https://dublab.us20.list-manage.com/subscribe/post?u=81c8241e4e6ac4f506277d1cd&amp;id=70847da9c8"
    token="b_81c8241e4e6ac4f506277d1cd_70847da9c8"
    class="mailing-list"
  >
    <div slot="label" class="label">Subscribe to our Newsletter</div>
  </mailing-list>
</template>

<script>
import MailingList from '@/lib/mailing-list'

export default {
  name: 'SupportSection',
  components: { MailingList }
}
</script>

<style scoped>
.mailing-list {
  margin-bottom: 4rem;
}

.mailing-list >>> form {
  display: flex;
  flex-wrap: wrap;
}

.mailing-list >>> .label {
  width: 100%;
  margin-bottom: 1rem;
}

.mailing-list >>> .email {
  border: 1px solid black;
  padding: var(--p2);
  min-width: 50%;
  flex: 1;
}

.mailing-list >>> .email::placeholder { color: var(--grey); }
.mailing-list >>> .email::-moz-placeholder { color: var(--grey); }
.mailing-list >>> .email:-moz-placeholder { color: var(--grey); }

.mailing-list >>> .submit {
  border: 1px solid black;
  border-left: 0;
  width: 13rem;
  text-align: center;
  padding: var(--p2);
}

.mailing-list >>> [aria-hidden="true"] {
  width: 0;
}

.mailing-list >>> .error-message {
  padding-top: 1rem;
  color: red;
}
</style>

<style>
.no-touch .mailing-list .submit:hover {
  background-color: var(--accent);
  color: #fff;
}
</style>